import I18n from 'i18n-js'

import EmailSettingsForm, { EmailSettingsConnect } from './EmailSettingsForm'

const trOpt = { scope: 'settings.weeklySummaryEmail' }

class WeeklySummaryEmail extends EmailSettingsForm {
  constructor (props) {
    super(props)

    this.settingId = 'weeklySummary'
    this.showSentTestButton = true
    this.generateSubjectFields(['adminSubject', 'managerSubject', 'learnerManagerSubject'], trOpt)
  }

  get headerId () {
    return 'settings-weekly-summary-header'
  }

  get title () {
    return I18n.t('title', trOpt)
  }

  get description () {
    return I18n.t('description', trOpt)
  }

  get successMsg () {
    return I18n.t('successMessage', trOpt)
  }

  get failureMsg () {
    return I18n.t('errorMessage', trOpt)
  }
}

export default EmailSettingsConnect(WeeklySummaryEmail)
